import { FC, ReactNode } from "react";
import { Flex } from "@chakra-ui/react";
import { FullBleedSection } from "~/components";

interface Props {
  children: ReactNode;
  px?: number;
}

export const InterstitialPageContainer: FC<Props> = ({ children }) => {
  return (
    <FullBleedSection bg="th.cream1" flexGrow={1} justify="flex-start">
      <Flex flexGrow={1} w="full">
        {children}
      </Flex>
    </FullBleedSection>
  );
};
